import { render, staticRenderFns } from "./ScoreCheckDialog.vue?vue&type=template&id=8961ec9c&scoped=true&"
import script from "./ScoreCheckDialog.vue?vue&type=script&lang=js&"
export * from "./ScoreCheckDialog.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCheckDialog.vue?vue&type=style&index=0&id=8961ec9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8961ec9c",
  null
  
)

export default component.exports